import { AppMedError } from '../error/AppMedError.ts';
import Utils from './utils.ts';

export const errorCodeOf = (error: unknown) => (error instanceof AppMedError ? error.errorCode : undefined);

export const retryAfterSecondsOf = (error: unknown) => {
    if (!(error instanceof AppMedError) || error.errorCode !== 'WaitBeforeNewCode') return undefined;
    const seconds = error.contextData?.retryAfterSeconds;
    return typeof seconds === 'number' ? seconds : undefined;
};

export const smsNumberOf = (error: unknown) => {
    const smsNumber = error instanceof AppMedError ? error.contextData?.smsNumber : undefined;
    return typeof smsNumber === 'string' ? Utils.formatPhoneNumber(smsNumber) : '';
};

export const formatWait = (seconds: number) => (seconds < 60 ? `${seconds} s` : `${Math.ceil(seconds / 60)} min`);
